import React from 'react';
import { Box, Container, Link as LinkMUI, SvgIcon, Typography } from '@material-ui/core'

const Title = ({ children }) => (
  <Typography variant="h5" style={{ marginTop: "1em" }}>
    {children}
  </Typography>
)
const Paragraph = ({ children }) => (
  <Typography variant="body1" style={{ marginTop: "0.8em" }}>
    {children}
  </Typography>
)

export const Consent = () => {
  return (
    <>
      <Container maxWidth="md">
        <Box mt={3}>
          <Box mb={2} display='flex' justifyContent='center' alignItems='center'>
            <Box display='flex' alignItems='center'>
              <Box mr={1}>
                <SvgIcon component="object">
                  <embed type="image/svg+xml" src="/favicon.svg" width="24"/>
                </SvgIcon>
              </Box>
              <Typography variant="h3">
                <LinkMUI href="https://medevio.cz/" underline="hover" color="textPrimary">
                  MEDEVIO
                </LinkMUI>
              </Typography>
            </Box>
          </Box>
          <Box mt={2} mb={3}>
            <Typography variant="h3" align='center'>
              Souhlas pacienta se zpracováním osobních údajů
            </Typography>
          </Box>
          <Paragraph>
            Vážená pacientko, Vážený paciente,
          </Paragraph>
          <Paragraph>
            právě jste se rozhodl/a zapojit do národního průzkumu s názvem
            <strong>
              „Mapování příznaků a obtíží spojených s postcovidovým syndromem (tzv. long covid)“
            </strong> (dále jen „průzkum“), jehož cílem je popsat charakteristiky
            příznaků a obtíží spojených s postcovidovým syndromem u pacientů v České republice. Průzkum je určen
            pro všechny, kteří v minulosti prodělali nemoc COVID-19 (pozitivní PCR nebo antigenní test) a jsou ochotni
            pomoci se sledováním dlouhodobých příznaků a následků tohoto onemocnění. Zároveň získáte souhrn Vašich
            odpovědí, které můžete předložit pro případnou konzultaci s Vaším lékařem. Tento průzkum realizuje
            společnost Medevio s.r.o. se sídlem Sudoměřská 1413/2, Žižkov, 130 00 Praha 3, IČ: 09675400, zapsané v
            obchodním rejstříku vedeném Městským soudem v Praze, sp.zn. C 340224, bude tedy správcem dat (dále jen
            „správce“). Společnost Medevio s.r.o. bude také data zpracovávat a pro vědecké účely dále poskytovat pouze
            souhrnné výstupy bez možnosti identifikace jednotlivých pacientů, je tedy i zpracovatelem Vašich osobních
            údajů (dále jen „zpracovatel“).
          </Paragraph>
          <Title>
            Právní základ zpracování
          </Title>
          <Paragraph>
            Vaše osobní údaje budou zpracovávány na základě Vašeho souhlasu pro účely realizace tohoto průzkumu a
            následného vyhodnocení údajů získaných v rámci tohoto průzkumu.
          </Paragraph>
          <Title>
            Účel a rozsah zpracování osobních údajů
          </Title>
          <Paragraph>
            Cílem tohoto průzkumu je získat informace o charakteristice příznaků a obtíží spojených s postcovidovým
            syndromem, tzv. long covid. Společnost Medevio s.r.o. bude zpracovávat osobní údaje Vás jako
            identifikovatelné
            osoby (emailová adresa) pouze za účelem případné komunikace s Vámi ohledně doplnění nebo upřesnění sbíraných
            dat, a to pouze v případě, že to bude nezbytně nutné pro naplnění cíle průzkumu. Zpracovatel bude
            shromažďovat
            všechny níže uvedené osobní údaje a dále je zpracovávat společně s údaji všech ostatních účastníků průzkumu.
            Tyto údaje budou zpracovávány na základě udělení Vašeho souhlasu, a to tak, že vyplníte elektronický
            dotazník,
            tím udělíte Správci souhlas a povolení spravovat a Zpracovateli povolení zpracovávat následující data:
            <ul>
              <li>
                Demografické údaje (pohlaví, věk, životní situace, emailová adresa)
              </li>
              <li>
                Údaje o onemocnění COVID-19 (datum testu, příznaky onemocnění, hospitalizace, kyslíková terapie,
                návštěvy lékaře)
              </li>
              <li>
                Údaje týkající se očkování (počet dávek, datum poslední dávky)
              </li>
              <li>
                Údaje o následcích onemocnění COVID-19 (aktuální stav příznaků)
              </li>
            </ul>
          </Paragraph>
          <Title>
            Příjemci osobních údajů
          </Title>
          <Paragraph>
            K Vašim osobním údajům, na základě, kterých je možné Vaši osobu identifikovat (pohlaví, věk, emailová
            adresa),
            bude mít přístup pouze Správce, případně pověření pracovníci Správce podílející se na realizaci průzkumu.
            Budou-li údaje dále šířeny, Správce zajistí, aby zveřejněné údaje byly plně anonymizované, tak aby nebylo
            možné zpětně zjistit totožnost účastníků průzkumu. Osobní údaje mohou být zpřístupněny také kontrolním a
            jiným
            orgánům při výkonu jejich kontrolní nebo jiné úřední činnosti. Tyto osoby jsou vázány povinnou mlčenlivostí.
            Veškeré zpracování Vašich osobních údajů bude provedeno tak, aby byla vyloučena identifikace nepovolanou
            osobou.
          </Paragraph>
          <Title>
            Doba zpracování osobních údajů
          </Title>
          <Paragraph>
            Vaše osobní údaje budou uchovávány a zpracovávány po dobu nezbytnou vzhledem k účelu, za kterým byly
            shromážděny, případně do odvolání Vašeho souhlasu (podle toho, která skutečnost nastane dříve), nejdéle však
            5 let po ukončení průzkumu.
          </Paragraph>
          <Title>

            Vaše práva ve vztahu k osobním údajům
          </Title>
          <Paragraph>
            Poskytnutí Vašich osobních údajů spravovaných a zpracovávaných na základě tohoto souhlasu je dobrovolné.
            Máte
            právo kdykoliv požadovat přístup k Vašim osobním údajům, jejich opravu nebo výmaz, popřípadě omezení
            zpracování, vznést námitku proti zpracování a v rozsahu příslušných právních předpisů na ochranu osobních
            údajů, máte také právo na přenositelnost údajů. Máte také právo kdykoliv odvolat svůj souhlas se zpracováním
            osobních údajů. Odvoláním souhlasu však nebude dotčena zákonnost zpracování Vašich osobních údajů Správcem
            na
            základě Vašeho souhlasu před jeho odvoláním.
            Pokud chcete využít svého práva, zašlete prosím příslušný požadavek poštou na adresu sídla Medevio s.r.o. se
            sídlem Sudoměřská 1413/2, Žižkov, 130 00 Praha 3 nebo elektronicky na e-mailovou adresu <LinkMUI
            href='mailto:pomocnik@medevio.cz'>pomocnik@medevio.cz</LinkMUI>.
            Společnost Medevio s.r.o. Vás bude informovat v okamžiku, kdy se tak stane.
            Vezměte prosím také v potaz, že proti zpracování Vašich osobních údajů máte právo vznést námitku u Úřadu pro
            ochranu osobních údajů České republiky.
          </Paragraph>
          <Paragraph>
            <strong>
              Moc Vám děkujeme za pomoc a účast v tomto průzkumu!
            </strong>
          </Paragraph>
        </Box>

        <Box display='flex' justifyContent='center' mt={3}>
          <Typography variant='body2'>
            &copy; Medevio 2022
          </Typography>
        </Box>
      </Container>
    </>
  )
}
